import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/localization/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/markets' });
  },
});
